<main class="main-home-secton">
  <div class="event-main">
    <div class="container">
      <div class="blog-header">
        <div class="d-flex">
          <h6 class="mr-3">Blog __</h6>
          <div class="mr-3">
            <ion-icon name="time-outline"></ion-icon>
            {{ blogView.createdDate }} ago
          </div>
          <div>
            <ion-icon name="eye-outline"></ion-icon>
            {{ blogView.viewedCount }} read
          </div>
          <div class="ml-auto back-icon">
            <ion-icon name="arrow-back-outline" (click)="backBtn()"></ion-icon>
          </div>
        </div>
      </div>
      <div class="blogs-title">
        <h1>{{ blogView.blogName }}</h1>
      </div>
      <div class="blog-img-div">
        <div id="carouselCaptions" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner">
            <div
              class="carousel-item carosal{{ j }}"
              *ngFor="let image of blogView.blogImages; let j = index"
            >
              <img
                [src]="image.blogImageName"
                class="d-block blog-full-img"
                alt="..."
              />
            </div>
          </div>
        </div>
      </div>
      <div [innerHtml]="blogView.blogContent | safeHtml"></div>
    </div>
  </div>
</main>
<app-footer></app-footer>
